import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import get from 'lodash/get';
import find from 'lodash/find';

import { usePrevious } from 'shared-components/utils/hooks/use-previous';

import { AttachmentsAnnouncementModal } from './attachments-announcement-modal';
import { updateExperience } from '../../../../app-main/actions/nux';

// Release date of stream inbox v0
const RELEASE_DATE = moment([2024, 9, 24]).toDate();

const AttachmentsAnnouncement = ({ newInboxExperienceId, isHost, dispatch }) => {
  const [showModal, setShowModal] = useState(false);
  const prevShowModal = usePrevious(showModal);

  const updateNewInboxNux = useCallback(() => {
    dispatch(updateExperience(newInboxExperienceId));
  }, [newInboxExperienceId, dispatch]);

  useEffect(() => {
    if (newInboxExperienceId && isHost) {
      setShowModal(true);
    }
  }, [newInboxExperienceId, isHost]);

  useEffect(() => {
    if (prevShowModal && !showModal) {
      updateNewInboxNux();
    }
  }, [prevShowModal, showModal]);

  return (
    <AttachmentsAnnouncementModal
      show={showModal}
      setShowModal={setShowModal}
      releaseDate={RELEASE_DATE}
    />
  );
};

const mapStateToProps = (state = {}) => {
  const newExperiences = get(state, 'nux.experiences', []);
  const isHost = get(state, 'profile.data.is_host', false);
  const newInboxExperience = find(newExperiences, (experience) => 'new-inbox' === experience.name);
  const newInboxExperienceId = get(newInboxExperience, '_id', null);

  return {
    newInboxExperienceId,
    isHost
  };
};

AttachmentsAnnouncement.propTypes = {
  newInboxExperienceId: PropTypes.string,
  isHost: PropTypes.bool,
  dispatch: PropTypes.func
};

exports.AttachmentsAnnouncement = connect(mapStateToProps)(AttachmentsAnnouncement);
